var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbarSuggestionCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61,
    fill: "none",
    viewBox: "0 0 62 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D5DD",
    strokeWidth: 2,
    d: "M57 27C57 12.64 45.36 1 31 1S5 12.64 5 27"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 26,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 24.5,
    fill: "#fff",
    stroke: "#1E0AF5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "m33.58 27.013 5.095-5.098a1.105 1.105 0 0 0 0-1.556l-1.037-1.038a1.105 1.105 0 0 0-1.557 0l-5.095 5.098-5.067-5.067a1.105 1.105 0 0 0-1.556 0l-1.038 1.038a1.105 1.105 0 0 0 0 1.557l5.066 5.066-5.061 5.059a1.105 1.105 0 0 0 0 1.556l1.038 1.038a1.105 1.105 0 0 0 1.556 0l5.062-5.058 5.071 5.071a1.105 1.105 0 0 0 1.557 0l1.038-1.038a1.105 1.105 0 0 0 0-1.556l-5.072-5.072Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 19h16v16H23z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 62,
    height: 61,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5449_80438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5449_80438",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbarSuggestionCloseIcon);
export default __webpack_public_path__ + "static/media/chatbar-suggestion-close-icon.4ad4e87a861a9fed37187b7b02b84022.svg";
export { ForwardRef as ReactComponent };